'use client';

import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Badge } from "../Badge/Badge.js";
import { itemSuffix } from "./MenuItem.css.js";
function MenuItemStatus(props) {
  const { status, disabled } = props;
  if (!(status == null ? void 0 : status.label)) return null;
  const { label } = status;
  const labelIsNumber = useMemo(
    () => typeof label === "number" || !Number.isNaN(parseFloat(label)),
    [label]
  );
  const statusVariant = useMemo(
    () => labelIsNumber ? "primary" : "neutral",
    [labelIsNumber]
  );
  return /* @__PURE__ */ jsx(
    Badge,
    {
      a11yLabel: status.a11yLabel || void 0,
      className: itemSuffix,
      emphasis: disabled ? "medium" : "high",
      label: `${status.label}`,
      roundness: labelIsNumber ? "full" : "sm",
      variant: disabled ? "neutral" : statusVariant
    }
  );
}
export {
  MenuItemStatus
};
